
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/ubytovani",
      function () {
        return require("private-next-pages/[region]/[resort]/ubytovani.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/ubytovani"])
      });
    }
  